<div fxLayout="column">
  <lin-form-label [required]="required">{{ 'FIELDS.PREFERRED_LANGUAGE' | translate }}: </lin-form-label>
  <mat-form-field>
    <mat-select [formControl]="control">
      @for (language of languages$ | async; track language.value) {
      <mat-option [value]="language.value">{{ language.label }}</mat-option>
      }
    </mat-select>
    <mat-error>
      <lin-form-field-error></lin-form-field-error>
    </mat-error>
  </mat-form-field>
</div>
